import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { NotificationManager } from "react-notifications";
import { ESTADOS_ORDEN_PRODUCCION } from "../../../../../../../../../../utility/constants";
import { PalletsTable } from "./PalletsTable";
import { PalletForm } from "./PalletForm";
import { ModalReclasificacion } from "../ModalReclasificacion/ModalReclasificacion";
import { ModalSobrante } from "../ModalSobrante/ModalSobrante";
import { ModalNumeroPallet } from "../ModalNumeroPallet/ModalNumeroPallet";
import { calcularTotalesSobrante } from "../../hooks/useSobranteReclasificacion";

export const ListadoPallets = (props) => {
    const {
        prodSinPaletizar = {},
        siguienteNumeroPallet,
        pallets = [],
        CrearPallet,
        EliminarPallet,
        ActualizarEstadoConformePallet,
        reclasificacionRefreshKey,
        reclasificacionPendiente,
        sobrantePendiente,
    } = props;

    const palletForm = useForm({
        mode: "onChange",
    });

    const {
        trigger: validateForm,
        reset: formReset,
        watch: formWatch,
    } = palletForm;

    const formValues = formWatch();
    const productoId =
        formValues && formValues.evs ? formValues.evs.producto_id : undefined;

    const AgregarPallet = async () => {
        const isValid = await validateForm();
        if (!isValid) return;

        const inventariosReclasificacionConConsumo =
            inventariosReclasificacion.filter(
                (inv) =>
                    inv.pacas_a_consumir && parseInt(inv.pacas_a_consumir) > 0,
            );

        const totalesSobrante = calcularTotalesSobrante(
            sobrantesReclasificacion,
        );

        // Verificar que hayan pacas de turno actual o anterior, reclasificación o sobrante
        if (
            (!formValues.pacas_turno_actual ||
                formValues.pacas_turno_actual === "0") &&
            (!formValues.pacas_turno_anterior ||
                formValues.pacas_turno_anterior === "0") &&
            inventariosReclasificacionConConsumo.length === 0 &&
            totalesSobrante.seleccionados.length === 0
        ) {
            NotificationManager.error(
                "Debe ingresar pacas de turno actual o turno anterior",
                "Error",
                3000,
            );
            return;
        }

        // No se valida que los pallets tengan máximo 36 pacas
        // porque en la realidad algunos pallets buscan superar esa cantidad.

        const nuevoPallet = {
            ...formValues,
            estado: ESTADOS_ORDEN_PRODUCCION.PENDIENTE,
            es_conforme: true,
            orden_produccion_id: formValues.evs.orden_produccion_id,
            consumos_reclasificacion: inventariosReclasificacionConConsumo.map(
                (inv) => ({
                    inventario_reclasificacion_id: inv.id,
                    cantidad_a_consumir: parseInt(inv.pacas_a_consumir),
                }),
            ),
            consumos_sobrante: totalesSobrante.seleccionados.map(
                (existencia) => ({
                    existencia_id: existencia.id,
                    kg_secos: parseFloat(existencia.kg_a_consumir),
                }),
            ),
            pallet_rechazado_id: palletRechazado ? palletRechazado.id : null,
        };

        try {
            // Agregar nuevo pallet al estado
            await CrearPallet(nuevoPallet);

            // Limpiar campos del formulario
            formReset({
                // conservar el campo de evs
                evs: formValues.evs,
                pacas_turno_actual: "",
                pacas_turno_anterior: "",
                pacas_reclasificacion: "",
            });
            setInventariosReclasificacion([]);
            setSobrantesReclasificacion([]);
            setPalletRechazado(null);
        } catch (error) {
            console.error("Error al crear pallet:", error);
        }
    };

    // número que tomará el pallet: el de un pallet rechazado que se está
    // volviendo a formar, o uno nuevo cuando no hay ninguno seleccionado
    const [palletRechazado, setPalletRechazado] = useState(null);
    const [mostrarModalNumeroPallet, setMostrarModalNumeroPallet] =
        useState(false);

    const AbrirModalNumeroPallet = () => {
        setMostrarModalNumeroPallet(true);
    };

    // comportamiento de reclasificación
    const [inventariosReclasificacion, setInventariosReclasificacion] =
        useState([]);
    const [mostrarModalReclasificacion, setMostrarModalReclasificacion] =
        useState(false);

    const AbrirModalReclasificacion = () => {
        setMostrarModalReclasificacion(true);
    };

    // comportamiento de sobrante en reclasificación
    const [sobrantesReclasificacion, setSobrantesReclasificacion] = useState(
        [],
    );
    const [mostrarModalSobrante, setMostrarModalSobrante] = useState(false);

    const AbrirModalSobrante = () => {
        setMostrarModalSobrante(true);
    };

    return (
        <React.Fragment>
            <PalletForm
                prodSinPaletizar={prodSinPaletizar}
                siguienteNumeroPallet={siguienteNumeroPallet}
                palletRechazado={palletRechazado}
                AbrirModalNumeroPallet={AbrirModalNumeroPallet}
                form={palletForm}
                AgregarPallet={AgregarPallet}
                AbrirModalReclasificacion={AbrirModalReclasificacion}
                inventariosReclasificacion={inventariosReclasificacion}
                reclasificacionPendiente={reclasificacionPendiente}
                AbrirModalSobrante={AbrirModalSobrante}
                sobrantesReclasificacion={sobrantesReclasificacion}
                sobrantePendiente={sobrantePendiente}
            />

            <PalletsTable
                pallets={pallets}
                EliminarPallet={EliminarPallet}
                ActualizarEstadoConformePallet={ActualizarEstadoConformePallet}
            />

            <ModalNumeroPallet
                opened={mostrarModalNumeroPallet}
                onClose={() => setMostrarModalNumeroPallet(false)}
                palletRechazado={palletRechazado}
                setPalletRechazado={setPalletRechazado}
            />

            <ModalReclasificacion
                opened={mostrarModalReclasificacion}
                onClose={() => setMostrarModalReclasificacion(false)}
                inventariosReclasificacion={inventariosReclasificacion}
                setInventariosReclasificacion={setInventariosReclasificacion}
                productoId={productoId}
                refreshKey={reclasificacionRefreshKey}
                reclasificacionPendiente={reclasificacionPendiente}
            />

            <ModalSobrante
                opened={mostrarModalSobrante}
                onClose={() => setMostrarModalSobrante(false)}
                sobrantesReclasificacion={sobrantesReclasificacion}
                setSobrantesReclasificacion={setSobrantesReclasificacion}
                productoId={productoId}
                refreshKey={reclasificacionRefreshKey}
                sobrantePendiente={sobrantePendiente}
            />
        </React.Fragment>
    );
};
